/* eslint-disable jsx-a11y/label-has-associated-control */

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import {
    Box,
    Card,
    Grid,
    Container,
    CardContent,
    CardActions,
    Button,
    FormControlLabel,
    Checkbox
} from "@mui/material";

import useForm from "../../hooks/validation";

import LoadingButton from "../../shared/loadingButton/LoadingButton";
import { placeholderStye } from "../../theme/style";
import MuiTextField from "../../theme/TextField";
import { getErrorMessage } from "../../utils";
import gellaryServices from "../../services/gellaryServices";

const initialValues = {
    caption: "",
    isSlider: false,
};

const validationRules = {
    caption: (value) => (value ? "" : "This field is required"),
};

const CreateGellery = () => {
    const navigate = useNavigate();
    const { values, errors, handleOnChange, validateAllFields, setFormValues } =
        useForm(initialValues, validationRules);

    const [images, setImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        const newImages = files.filter(file => file.size / (1024 * 1024) <= 3);
        if (newImages.length !== files.length) {
            toast.error("Some files exceed the maximum limit of 3 MB.");
        }

        setImages(prevImages => [...prevImages, ...newImages]);
    };

    const removeImage = (index) => {
        setImages(prevImages => prevImages.filter((_, i) => i !== index));
    };

    const handleSubmit = async () => {
        const data = new FormData();
        data.append('caption', values.caption);
        data.append('isSlider', values.isSlider);

        images.forEach((item) => (
            data.append('images', item)

        ))


        // const dataToSend = {
        //     ...values,
        //     images,
        // };
        if (validateAllFields()) {
            setIsLoading(true);
            gellaryServices
                .create(data)
                .then(() => {
                    toast.success("created successfully");
                    navigate(-1);
                })
                .catch((err) => {
                    toast.error(getErrorMessage(err));
                })
                .finally(() => setIsLoading(false));
        }
    };

    return (
        <Container>
            <Card sx={{ padding: "1rem" }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>

                            <Box width="100%" display="flex" flexWrap="wrap" gap={3}>
                                {images.map((image, index) => (
                                    <Box key={index} sx={{ position: "relative", display: "inline-block", margin: "5px", width: "100px", height: "100px" }}>
                                        <img
                                            src={URL.createObjectURL(image)}
                                            alt="uploaded"
                                            height="100px"
                                            width="100px"
                                            style={{ borderRadius: "5px", objectFit: "cover" }}
                                        />
                                        <Button
                                            size="small"
                                            onClick={() => removeImage(index)}
                                            sx={{ position: "absolute", top: 0, right: 0, background: "red", color: "white" }}
                                        >
                                            X
                                        </Button>
                                    </Box>
                                ))}
                            </Box>
                            <Button variant="contained" component="label" sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>
                                Add Image
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={handleFileChange}
                                />
                            </Button>
                        </Grid>



                        <Grid item xs={12}>
                            <MuiTextField
                                label="caption"
                                name="caption"
                                value={values.caption}
                                error={errors.caption}
                                helperText={errors.caption}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="caption"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={values.isSlider}
                                        onChange={(e) => setFormValues({ ...values, isSlider: e.target.checked })}
                                        name="isSlider"
                                    />
                                }
                                label="Add to slider to display image in slider"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <LoadingButton
                        isLoading={isLoading}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Add Gallery
                    </LoadingButton>
                </CardActions>
            </Card>
        </Container>
    );
};

export default CreateGellery;
